import AppHeader from '@/components/layout/AppHeader'

export default function TermsOfService() {
  return (
    <div className="flex flex-col h-full bg-white">
      <AppHeader title="Terms of Service" showBack />
      <div className="screen no-scrollbar px-4 sm:px-6 lg:px-8 py-5">
        <div className="mx-auto w-full max-w-4xl card space-y-3">
          <p className="text-sm text-slate-700 leading-relaxed">
            By using GoodGuardian, you agree to use the platform lawfully and responsibly. You must provide
            accurate account information and protect your login credentials.
          </p>
          <p className="text-sm text-slate-700 leading-relaxed">
            GoodGuardian content is for legal education and workflow support only. It is not attorney-client advice,
            legal representation, or a substitute for licensed counsel.
          </p>
          <p className="text-sm text-slate-700 leading-relaxed">
            You are responsible for all submissions and decisions made using the platform. GoodGuardian may update
            features and policies to improve safety, compliance, and service quality.
          </p>
          <p className="text-xs text-slate-500">Last updated: March 24, 2026</p>
        </div>
      </div>
    </div>
  )
}
